export const ActionTypes = {
  INIT_USER: 'USER/INIT',
  USER_LOGGED_IN: 'USER/LOGGED_IN',
  FETCH_USER: 'USER/FETCH',
  GET_USER: 'USER/GET',
  GET_USER_ERROR: 'USER/GET_USER_ERROR',
  SET_USER: 'USER/SET',
  SET_USER_ERROR: 'USER/SET_ERROR',
  FETCH_TOKEN: 'TOKEN/FETCH',
  LOAD_AUTH: 'AUTH/LOAD',
  LOGIN: 'AUTH/LOGIN',
  LOGOUT: 'AUTH/LOGOUT',
  LOGOUT_ERROR: 'AUTH/LOGOUT_ERROR',
  AUTH_COMPLETE: 'AUTH/COMPLETE',
  REFRESH_AND_FETCH: 'AUTH/REFRESH_AND_FETCH',
  UPGRADE: 'AUTH/UPGRADE',
  UPGRADE_SUCCESS: 'AUTH/UPGRADE_SUCCESS',
  DATA_MIGRATION_STATUS: 'USER/DATA_MIGRATION_STATUS',
  START_DATA_MIGRATION_TIMER: 'USER/START_DATA_MIGRATION_TIMER',
  END_DATA_MIGRATION_TIMER: 'USER/END_DATA_MIGRATION_TIMER',
  DATA_MIGRATION_TICK: 'USER/DATA_MIGRATION_TICK',
  HANDLE_CORRUPT_TOKEN: 'AUTH/HANDLE_CORRUPT_TOKEN',
  SET_SELECTED_USER_TYPE: 'SET_SELECTED_USER_TYPE',
  SET_SELECTED_SCHOOL_TYPE: 'SET_SELECTED_SCHOOL_TYPE',
  SET_PAPER_UPLOADED: 'USER/SET_PAPER_UPLOADED',
  UPGRADE_CITATION: 'AUTH/UPGRADE_CITATION',
  START_AUTH_FLOW: 'START_AUTH_FLOW',
} as const
